import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle, BookOpen, PlayCircle } from 'react-feather';
import useAudience, { helpBase } from './useAudience';
import { openWelcomeGuide } from './WelcomeGuide';

/** Question-mark button in the top bar: help centre and the getting-started guide. */
const HelpMenu = () => {
  const audience = useAudience();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  return (
    <div className="hm" ref={ref}>
      <button type="button" className="ed-icon-btn" aria-label="Help" aria-expanded={open} aria-haspopup="menu" onClick={() => setOpen((o) => !o)}>
        <HelpCircle size={20} />
      </button>
      {open && (
        <div className="hm-menu" role="menu">
          <Link role="menuitem" to={helpBase(audience)} onClick={() => setOpen(false)}>
            <BookOpen size={16} aria-hidden="true" /> Help centre
          </Link>
          <button
            type="button"
            role="menuitem"
            onClick={() => {
              setOpen(false);
              openWelcomeGuide();
            }}
          >
            <PlayCircle size={16} aria-hidden="true" /> Getting-started guide
          </button>
        </div>
      )}
    </div>
  );
};

export default HelpMenu;
